<header>
  <div class="header-fluid container-fluid d-lg-flex justify-content-between align-items-center px-md-3 px-lg-4 px-xl-5">
      <span class="hamburger d-sm-block d-md-none" [class.is-active]="isMenuOpen" (click)="menuOpen()">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </span>
    <div class="logo col-xl-4 col-lg-3 col-8 pe-lg-3 mx-auto my-2 mx-lg-0 my-lg-0">
      <a routerLink="/"><img src="assets/images/logo.svg" alt="logo"></a>
    </div>
    <div class="header-right col-xl-7 col-lg-9 col-md-12 d-md-flex justify-content-md-between align-items-center ps-lg-4">
      <div class="menu" [class.menu-open]="isMenuOpen">
        <a routerLink="view-integrations" routerLinkActive="is-active">View Integrations</a>
      <!--  <a routerLink="payer-enquiry" routerLinkActive="is-active">Payer Enquiry</a>-->
      </div>
      <div class="sign-menu text-center text-md-end">
        <a href="{{applyNowUrl}}" target="_blank" mat-stroked-button color="primary" class="my-2 me-3">Apply Now</a>
        <a href="{{signInUrl}}" target="_blank" mat-raised-button color="primary"  class="my-2">Sign In</a>


<!--
        <button mat-stroked-button color="primary" (click)="redirect(signUpUrl)" class="my-3 me-3">Sign Up</button>
        <button mat-raised-button color="primary" (click)="redirect(signInUrl)" class="my-3">Sign In</button>
 -->
      </div>
    </div>
  </div>
</header>
